import { createContext, useContext } from 'react';

const ActiveProductContext = createContext({});

export const ActiveProductProvider = ActiveProductContext.Provider;

export const useActiveProduct = <Product,>() => useContext(ActiveProductContext) as Product;
